import styled from 'styled-components';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import { mediaMin, mediaMax } from 'common/styledMixins';
import { zIndex, color, breakpoint } from 'common/styledVars';
import { BaseP, HeaderLarge, BaseTransparentP, HeaderMedium } from 'components/typography';

import ArrowButton from 'components/Button/ArrowButton';
import { WidthWrapper } from 'components/wrappers';

export const GatsbyImage = styled(Img).attrs({ style: { position: 'initial' } })``;

export const Wrapper = styled(WidthWrapper)`
  position: relative;
  z-index: ${zIndex.body + 1};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  ${BaseP} {
    line-height: 35px;
    color: ${color.black};
    font-weight: 600;
  }

  ${BaseTransparentP} {
    max-width: 660px;
    color: ${color.black};
  }

  ${HeaderLarge} {
    margin: 140px 0 40px;
    max-width: 1000px;
  }

  ${ArrowButton} {
    margin: 30px 0 30px;
  }

  @media only screen and (max-width:981px) {
    ${ArrowButton} {
      margin-top:25px;
      margin-bottom:35px;
    }

  }
`;

export const FullImageBox = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 500px;
  display: flex;
  z-index: ${zIndex.body};
  @media ${mediaMin(breakpoint.desktop)} {
    bottom: 30%;
  }
`;

export const SvgWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  height: 1440px;
  display: none;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: ${zIndex.body + 1};

  & > div {
    width: 1582px;
    height: 1440px;
    border-radius: 50%;
    background-color: ${color.white};
  }

  @media ${mediaMin(breakpoint.desktop)} {
    display: flex;
  }
`;

export const DownLink = styled(Link)`
  position: absolute;
  top: 1017px;
  left: 50%;

  width: 62px;
  height: 62px;
  border-radius: 50%;
  background-color: #00af85;
  transform: translate(-50%, 0);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-top: 3px;
    path {
      fill: ${color.white};
    }
  }
`;

export const MobileReasonsBox = styled.div`
  ${HeaderMedium} {
    margin: 16px 0 32px;
  }

  @media ${mediaMin(breakpoint.desktop)} {
    display: none;
  }
`;

export const MobileReasons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  overflow: hidden;

  svg {
    margin: -60px -55px;
  }
`;
